import React from "react"
import { Link } from "react-router-dom"
import { motion } from "framer-motion"
import heroImg from "../../Assets/campus1.jpg"

const programs = [
	{
		number: "01",
		icon: "ri-graduation-cap-line",
		title: "Integrated +1 & +2 Education",
		desc: "Science & Commerce streams with a strong academic foundation and board exam excellence.",
		accent: "#174e4a",
	},
	{
		number: "02",
		icon: "ri-book-open-line",
		title: "Entrance Coaching",
		desc: "Structured preparation for NEET, JEE, KEAM, CUET and other national-level competitive exams.",
		accent: "#c4935a",
	},
	{
		number: "03",
		icon: "ri-briefcase-4-line",
		title: "Professional Pathways",
		desc: "CA Foundation preparation and early exposure to commerce & business career tracks.",
		accent: "#3a2942",
	},
	{
		number: "04",
		icon: "ri-global-line",
		title: "Global University Pathways",
		desc: "International admissions counseling, scholarship guidance, and profile development.",
		accent: "#174e4a",
	},
	{
		number: "05",
		icon: "ri-robot-line",
		title: "AI & Future Skills",
		desc: "Artificial Intelligence programs, leadership training, and digital career-ready skills.",
		accent: "#c4935a",
	},
]

const Programes = () => {
	return (
		<section className="programs-section-v2">
			<div className="container-main">

				<div className="programs-v2-header">
					<div className="programs-v2-header-left">
						<span className="programs-eyebrow">What We Offer</span>
						<h2 className="programs-v2-title montserrat">
							Our <span className="programs-v2-highlight">Programs</span>
						</h2>
					</div>
					<div className="programs-v2-header-right">
						<p className="programs-v2-subtitle">
							Every program is designed to take students from school academics straight into their chosen career path — under one residential roof.
						</p>
						<Link to="/acadamics" className="programs-v2-cta">
							Explore All Programs <i className="ri-arrow-right-line"></i>
						</Link>
					</div>
				</div>

				<div className="programs-v2-layout">
					<div className="programs-v2-list">
						{programs.map((prog, idx) => (
							<motion.div
								className="programs-v2-item"
								key={idx}
								initial={{ opacity: 0, x: -20 }}
								whileInView={{ opacity: 1, x: 0 }}
								viewport={{ once: true }}
								transition={{ duration: 0.45, delay: idx * 0.07 }}
							>
								<div
									className="programs-v2-item-bar"
									style={{ background: prog.accent }}
								/>
								<div
									className="programs-v2-icon"
									style={{ color: prog.accent, background: prog.accent + "14" }}
								>
									<i className={prog.icon}></i>
								</div>
								<div className="programs-v2-content">
									<div className="programs-v2-num" style={{ color: prog.accent }}>
										{prog.number}
									</div>
									<h3 className="programs-v2-item-title">{prog.title}</h3>
									<p className="programs-v2-item-desc">{prog.desc}</p>
								</div>
								<Link to="/acadamics" className="programs-v2-arrow" aria-label={`Learn more about ${prog.title}`}>
									<i className="ri-arrow-right-up-line"></i>
								</Link>
							</motion.div>
						))}
					</div>

					<motion.div
						className="programs-v2-visual"
						initial={{ opacity: 0, scale: 0.97 }}
						whileInView={{ opacity: 1, scale: 1 }}
						viewport={{ once: true }}
						transition={{ duration: 0.7 }}
					>
						<div className="programs-v2-img-wrap">
							<img src={heroImg} alt="Students studying at Branmont" />
						</div>
					
						<div className="programs-v2-badge-bottom">
							<div className="programs-v2-stat">
								<strong>5+</strong>
								<span>Career tracks</span>
							</div>
							<div className="programs-v2-stat-divider" />
							<div className="programs-v2-stat">
								<strong>100%</strong>
								<span>Residential</span>
							</div>
							<div className="programs-v2-stat-divider" />
							<div className="programs-v2-stat">
								<strong>+1/+2</strong>
								<span>Integrated</span>
							</div>
						</div>
					</motion.div>
				</div>
			</div>
		</section>
	)
}

export default Programes
